import React from 'react';
import PropTypes from 'prop-types';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Slide from '@mui/material/Slide';

function SlideTransition(props) {
  return <Slide {...props} direction="right" />;
}

function ToastMessage({
  message,
  open,
  severity,
  vertical,
  horizontal,
  onClose,
  alertProps,
  ...rest
}) {
  return (
    <Snackbar
      anchorOrigin={{ vertical, horizontal }}
      autoHideDuration={6000}
      TransitionComponent={SlideTransition}
      open={open}
      onClose={onClose}
      {...rest}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        elevation={6}
        variant="outlined"
        sx={{ width: '100%' }}
        {...alertProps}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}

ToastMessage.defaultProps = {
  open: false,
  severity: 'success',
  vertical: 'bottom',
  horizontal: 'left',
};

ToastMessage.propTypes = {
  message: PropTypes.string.isRequired,
  open: PropTypes.bool,
  severity: PropTypes.string,
  vertical: PropTypes.string,
  horizontal: PropTypes.string,
  onClose: PropTypes.func,
};

export default ToastMessage;
